import React, { useState } from 'react'
import { Container } from 'reactstrap'
import { useSelector } from 'react-redux'
import { DF_MO0004Context } from './context'
import GridHeader from './Grid/GridHeader'
import GridBody from './Grid/GridBody'
import GridFooter from './Grid/GridFooter'
import {
  fnGetValueByKey
} from '../../helpers/functions'
import withRouter from '../../components/Common/withRouter'
import useGetCsrfToken from '../../Hooks/useGetCsrfToken'

const DF_MO0004 = () => {  
  console.log('🤖 %cTransação [DF_MO0004]', 'color:green')  
  
  const { userProfile, isModalPage, access_token } = useSelector(state => ({
    userProfile: state.login.profile,
    isModalPage: state.Layout.isModalPage,
    access_token: state.login.user?.access_token,
  }))

  const csrfToken = useGetCsrfToken();

  const [isLoading, setisLoading] = useState(false)

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [paramsOnFilter, setParamsOnFilter] = useState([])
  const [triggerOnFilter, setTriggerOnFilter] = useState(false)
  const [inputGlobalSearchValue, setInputGlobalSearchValue] = useState('')
  const [filteredData, setFilteredData] = useState([])

  return (
    <React.Fragment>
      <DF_MO0004Context.Provider
        value={{
          isLoading,
          userProfile,
          setisLoading,
          isOpenModal,
          setIsOpenModal,
          paramsOnFilter,
          setParamsOnFilter,
          fnGetValueByKey,
          triggerOnFilter,
          setTriggerOnFilter,
          inputGlobalSearchValue,
          setInputGlobalSearchValue,
          filteredData,
          setFilteredData,
          csrfToken,
          access_token
        }}
      >
        <div style={{ padding: isModalPage && '0px', overflow: isModalPage && 'hidden'}}  className="page-content">
          <Container fluid={true} className="dataTable-custom-primary">
            <GridHeader context={DF_MO0004Context} />
            <GridBody />
          </Container>          
        </div>

        {!isModalPage && <>
          <GridFooter />
        </>}
        
      </DF_MO0004Context.Provider>
    </React.Fragment>
  )
}

export default withRouter(DF_MO0004)
